import gql from 'graphql-tag'

export const GET_PRODUCT_REVIEW_REPLY_PAGINATED_QUERY = gql`
  query (
    $reviewId: Int!,
    $skip: Int!,
    $take: Int!,
    $orderBy: [OrderByInput!]
  ) {
    getProductReviewReplyPaginated (
      data: {
        reviewId: $reviewId
        orderBy: $orderBy
        pagination: {
          skip: $skip
          take: $take
        }
      }
    ) {
      hasMore
      total
      items {
        id
        comment
        client {
          id
          fullName
          image
        }
        createdAt
      }
    }
  }
`;

export const GET_PRODUCT_REVIEW_REPLY_QUERY = gql`
  query (
    $id: Int!,
  ) {
    getProductReviewReply (
      data: {
        id: $id
      }
    ) {
      id
      client {
        id
        fullName
        image
      }
      comment
      createdAt
    }
  }
`;
